<template>
  <div class="course-search-input" :class="`course-search-input--${size}`">
    <el-input
      :value="value"
      :disabled="loading"
      class="course-search-field"
      :placeholder="placeholder"
      size="medium"
      @input="handleInput"
      @keyup.enter.native="handleSearch"
    ></el-input>
    <button
      type="button"
      class="course-search-icon-btn"
      :class="{ 'is-hidden': !value }"
      :disabled="loading"
      aria-label="清空关键词"
      @click.stop="handleClear"
    >
      <i class="el-icon-circle-close"></i>
    </button>
    <button
      type="button"
      class="course-search-icon-btn course-search-icon-btn--search"
      :disabled="loading || searchDisabled"
      aria-label="搜索课程"
      @click.stop="handleSearch"
    >
      <i :class="loading ? 'el-icon-loading' : 'el-icon-search'"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "CourseSearchInput",
  props: {
    value: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchDisabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请输入课程标题",
    },
    size: {
      type: String,
      default: "default",
      validator(value) {
        return ["default", "h5"].includes(value);
      },
    },
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },
    handleClear() {
      this.$emit("input", "");
      this.$emit("clear");
    },
    handleSearch() {
      if (this.loading || this.searchDisabled) return;
      this.$emit("search");
    },
  },
};
</script>

<style lang="scss" scoped>
.course-search-input {
  width: var(--course-search-width, 260px);
  height: var(--course-search-height, 38px);
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid var(--user-btn-border);
  border-radius: var(--course-search-radius, 19px);
  background: var(--input-bg);
  padding: var(--course-search-padding, 0 8px 0 16px);
  flex-shrink: 0;

  &--h5 {
    --course-search-width: 100%;
    --course-search-height: 0.96rem;
    --course-search-radius: 0.48rem;
    --course-search-padding: 0 0.2rem 0 0.36rem;
    --course-search-inner-height: 0.92rem;
    --course-search-btn-width: 0.56rem;
    --course-search-btn-height: 0.96rem;
    --course-search-btn-font-size: 0.4rem;

    background: var(--card-bg);

    .course-search-field {
      ::v-deep .el-input__inner {
        font-size: 0.35rem;
      }
    }
  }

  .course-search-field {
    flex: 1;
    min-width: 0;

    ::v-deep .el-input__inner {
      height: var(--course-search-inner-height, 36px);
      line-height: var(--course-search-inner-height, 36px);
      border: 0;
      border-radius: 0;
      background: transparent;
      color: var(--text-primary);
      padding: 0;
    }

    ::v-deep .el-input__inner::placeholder {
      color: var(--text-secondary);
    }
  }

  .course-search-icon-btn {
    width: var(--course-search-btn-width, 28px);
    height: var(--course-search-btn-height, 32px);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    padding: 0;
    background: transparent;
    cursor: pointer;
    color: var(--text-secondary);
    font-size: var(--course-search-btn-font-size, 16px);
    flex-shrink: 0;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    &--search:not(:disabled) {
      color: var(--brand-primary, #00c89d);
    }

    &.is-hidden {
      visibility: hidden;
      pointer-events: none;
    }
  }
}
</style>
